// extracted by mini-css-extract-plugin
module.exports = {"parent":"issues-module--parent--2A8Ci","heading":"issues-module--heading--4Pd1w","bottomMargin":"issues-module--bottomMargin--1KxNL"};